import { ReactNode } from 'react';

import { Box } from '../../Box';

/**
 * Свойства компонента {@link InputDisclaimer}
 */
interface InputDisclaimerProps {
  /**
   * Содержимое, которое будет отображено в компоненте.
   */
  children: ReactNode;

  /**
   * Смещение содержимого по вертикали от верхнего края родительского контейнера.
   *
   * @defaultValue `28`
   */
  top?: number;

  /**
   * Смещение содержимого по горизонтали от левого края родительского контейнера.
   *
   * @defaultValue `20`
   */
  left?: number;
}

/**
 * Компонент InputDisclaimer используется для отображения дополнительной информации
 * или предупреждений, связанных с полем ввода. Он размещает свое содержимое относительно
 * родительского контейнера с возможностью указать смещение по осям X и Y.
 *
 * @public
 * @param children - Содержимое, которое будет отображено в компоненте.
 * @param top - Смещение содержимого по вертикали от верхнего края родительского контейнера.
 * @param left - Смещение содержимого по горизонтали от левого края родительского контейнера.
 * @returns Компонент InputDisclaimer.
 *
 * @remarks
 *
 * Ссылка на свойства компонента {@link InputDisclaimerProps}
 */
export const InputDisclaimer = ({
  children,
  top = 28,
  left = 20,
}: InputDisclaimerProps) => (
  <Box width="100%" position="relative">
    <Box position="absolute" left={left} top={top}>
      {children}
    </Box>
  </Box>
);
